import React, { useMemo } from 'react';
import SiteCharts from '../../../components/SiteCharts';
import { saSignalingConnectionCellChartConfig } from '../cellChartConfigs';

interface SignalingConnectionSaCellProps {
  cellName: string;
  onFullscreenToggle: () => void;
  isFullscreen: boolean;
}

const SignalingConnectionSaCell: React.FC<SignalingConnectionSaCellProps> = ({ cellName, onFullscreenToggle, isFullscreen }) => {
  const additionalParams = useMemo(() => ({ cell_name: cellName }), [cellName]);
  return (
    <SiteCharts config={saSignalingConnectionCellChartConfig} onFullscreenToggle={onFullscreenToggle} isFullscreen={isFullscreen} additionalParams={additionalParams} />
  );
};

export default SignalingConnectionSaCell;
